import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { type DeviceTypeRecord } from "../DeviceTypeRecord";
import { type UpdateDeviceTypeRequest } from "../DeviceTypeService";

import { deviceTypeQueryKeys } from "./deviceTypeQueryKeys";

interface UpdateDeviceTypeParams {
  deviceTypeId: string;
  resourceOwnerId: string;
  updates: UpdateDeviceTypeRequest;
}

export function useUpdateDeviceType() {
  const { deviceTypes } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<DeviceTypeRecord, Error, UpdateDeviceTypeParams>({
    mutationFn: ({ deviceTypeId, resourceOwnerId, updates }) =>
      deviceTypes.updateDeviceType(deviceTypeId, updates, { resourceOwnerId }),
    onSuccess: (updated, { resourceOwnerId }) => {
      void queryClient.invalidateQueries({
        queryKey: deviceTypeQueryKeys.list(resourceOwnerId),
      });
      queryClient.setQueryData(
        deviceTypeQueryKeys.detail(updated.device_type_id),
        updated,
      );
    },
  });
}
